export default __webpack_public_path__ + "static/media/2018 (1).0bb50a84.jpg";